/* eslint-disable react-hooks/exhaustive-deps */
import Engine from '../../app/Engine';
import GlazeConsole from '../../helpers/GlazeConsole';
import { configurationSet } from '../../store/configuration/actions';
import { loadingInitialize } from '../../store/loading/actions';
import Blocked from '../Blocked';
import Congratulations from '../Congratulations';
import Helper from '../Helper/Helper';
import Menu from '../Menu';
import Options from '../Options';
import SecondaryMenu from '../SecondaryMenu/SecondaryMenu';
// import ShortBox from '../ShortBox';
import ToolBox from '../ToolBox';
import getDefaultTextureValues from './helpers/getDefaultTextureValues';
import useLoadMeasures from './hooks/useLoadMeasures';
import useLoadPresets from './hooks/useLoadPresets';
import useLoadShaders from './hooks/useLoadShaders';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// measures + presets + shaders + engine stages
const HOW_MANY_STAGES_IN_ENGINE = 4;
const HOW_MANY_STAGES = 1 + 1 + 1 + HOW_MANY_STAGES_IN_ENGINE;

const App = () => {
  const state = useSelector((s) => s);
  const { details, presets, measures, controlling, configuration } = state;
  const dispatch = useDispatch();
  const [canLoadData, setCanLoadData] = useState(false);
  const [showConfiguration, setShowConfiguration] = useState(false);
  const [ready, setReady] = useState(false);
  const engine = useRef();
  const glazeConsole = useRef();
  const textureValues = useMemo(getDefaultTextureValues, []);

  useLoadMeasures(canLoadData);
  const shaders = useLoadShaders(canLoadData);
  useLoadPresets(canLoadData);

  useEffect(() => {
    if (details?.id) {
      dispatch(loadingInitialize(HOW_MANY_STAGES));

      setCanLoadData(true);
    }
  }, [details?.id, dispatch]);

  useEffect(() => {
    if (shaders && presets && measures) {
      setShowConfiguration(true);
    }
  }, [shaders, presets, measures]);

  useEffect(() => {
    if (ready) {
      if (!glazeConsole.current) {
        glazeConsole.current = new GlazeConsole(dispatch);
      }

      if (glazeConsole.current) {
        glazeConsole.current.update(state);
      }

      if (!engine.current) {
        engine.current = new Engine(shaders, measures, dispatch, configuration.data);
      }

      if (engine.current) {
        engine.current.update(state);
      }
    }
  }, [ready, state]);

  useEffect(() => {
    if (configuration.done) {
      setReady(true);
    }
  }, [configuration.done]);

  useEffect(() => {
    if (showConfiguration) {
      dispatch(configurationSet(textureValues));
    }
  }, [showConfiguration]);

  if (!ready) {
    return null;
  }

  return (
    <>
      {engine.current && (
        <>
          <Menu engine={engine.current} />
          <SecondaryMenu engine={engine.current} />
          <Options engine={engine.current} />
        </>
      )}

      <ToolBox />
      <Helper />

      {controlling.blocked && <Blocked />}

      {details.sharedAs && <Congratulations id={details.sharedAs} />}
    </>
  );
};

export default App;
